// extracted by mini-css-extract-plugin
module.exports = {"tables":"FixService_tables__88EWN","tables__item":"FixService_tables__item__csOb0"};